/// <reference path="./globals.d.ts" />

import Vue, { CreateElement, VNode } from 'vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import Vuex from 'vuex'

Vue.use(VueI18n)
Vue.use(Vuex)
// istanbul ignore next
if (NODE_ENV !== 'test') {
  Vue.use(VueRouter)
}

export type { CreateElement, VNode }

export default Vue
